/**
 * A homepage list led by its CMS pins: every pin in pin order, then the rest,
 * each item once at its first place, cut to `limit` without dropping a pin.
 */
export const pinnedFirst = <T>(
    pinned: T[],
    rest: T[],
    idOf: (item: T) => number,
    limit: number,
): T[] => {
    const seen = new Set<number>();
    const unique = [...pinned, ...rest].filter((item) => {
        const id = idOf(item);
        if (seen.has(id)) return false;
        seen.add(id);
        return true;
    });
    return unique.slice(0, Math.max(limit, pinned.length));
};
